import { withRouter } from 'react-router';
import * as React from 'react';
import Footer from '../App/components/Layout/Footer/Footer';
import Header from '../App/components/Layout/Header/Header';
import MainNavigation from '../App/components/Layout/MainNavigation/MainNavigation';
import withRouteMetadata from '../App/hocs/withRouteMetadata';
import LogoutContainer from '../App/modules/Account/containers/Logout/LogoutContainer';
import BaseRoute from './_BaseRoute';

class LogoutRoute extends BaseRoute {
	public render() {
		return (
			<div>
				<Header />
				<MainNavigation />

				<LogoutContainer />

				<Footer />
			</div>
		);
	}
}

export default withRouter(
	withRouteMetadata(
		LogoutRoute,
		`logout`,
		{
			metaTitle: `Ausloggen | Aktionsfinder`,
		} as IRouteMetadataSetterType
	)
);
